import { lang } from "../../i18nLang";

class InvalidUserException extends Error {
  public readonly code: string;
  constructor() {
    super(lang("exceptions.auth.invalid-user"));
    this.name = "InvalidUserException";
    this.code = "invalid-user";
  }
}

class AuthException extends Error {
  public readonly code: string;
  static readonly codes = {
    ACCOUNT_WITH_DIFFERENT_CREDENTIAL:
      "account-exists-with-different-credential",
    INVALID_EMAIL: "invalid-email",
    EMAIL_IN_USE: "email-already-in-use",
    USER_NOT_FOUND: "user-not-found",
    WRONG_PASSWORD: "wrong-password",
    LOGIN_ERROR: "login-error",
    REGISTER_ERROR: "register-error",
    INTERNAL_ERROR: "internal-error",
    PASSWORD_RESET_ERROR: "password-reset-error",
    NETWORK_REQUEST_FAILED: "network-request-failed",
    TOO_MANY_REQUESTS: "too-many-requests",
    USER_DISABLED: "user-disabled",
    REQUIRES_RECENT_LOGIN: "requires-recent-login",
    //invalid-continue-uri
  };

  constructor(code: string, message?: string) {
    super(message);
    this.name = "AuthException";
    this.code = code;

    if (this.codeIsValid()) {
      this.message = !message ? lang(`exceptions.auth.${code}`) : message;
      return;
    }

    console.error(`Error code: `, code);
    this.message = !message
      ? lang(`exceptions.auth.${AuthException.codes.INTERNAL_ERROR}`)
      : message;
  }

  private codeIsValid() {
    return Object.values(AuthException.codes).includes(this.code);
  }
}

export { AuthException, InvalidUserException };
